export default __webpack_public_path__ + "static/focus-distractions-4f9891f199bba0005dc2ddcf68c5fb43.svg";